<div class="NgxEditor__Seperator"></div>
<div class="NgxEditor__MenuItem NgxEditor__MenuItem--Text" (mousedown)="openRepository(view)" [ngClass]="{'NgxEditor__MenuItem--Active': isActive, 'NgxEditor--Disabled': isDisabled}">
    <i class="fa-solid fa-film mt-1"></i>
</div>

<ng-template #view let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6>Insertar Video</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="form" (ngSubmit)="onSelected()">
            <input type="url" formControlName="link" class="form-control" placeholder="Pegue aquí en link de su video">
            <button type="submit" class="btn btn-round btn-success mt-2"><i class="fa-solid fa-check-double"></i></button>
        </form>
    </div>
</ng-template>